.panel {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-3);
  padding: var(--tuna-spacing-4);
}

.header {
  display: flex;
  justify-content: space-between;
  color: var(--tuna-content-secondary);
}

.score {
  font-weight: 600;
}

.prompt {
  font-size: var(--tuna-typography-h3-fontSize);
  margin: 0;
}

.hearBtn {
  align-self: flex-start;
}

.wheel {
  width: 100%;
  max-width: 480px;
  margin: 0 auto;
}
